import { CustomIcons } from '@shared/icons/CustomIcons'
import { Editor, useEditorState } from '@tiptap/react'
import { Button, Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'

type Props = {
  editor: Editor
}

export const UnorderedListButton = ({ editor }: Props) => {
  const { t } = useTranslation()

  const editorState = useEditorState({
    editor,
    selector: (ctx) => {
      return {
        isBulletList: ctx.editor.isActive('bulletList') ?? false
      }
    }
  })

  const onToggleBulletList = () => {
    editor.chain().focus().toggleBulletList().run()
  }

  return (
    <Tooltip title={t('editor.bullet_list')}>
      <Button
        icon={CustomIcons.UnorderedList(16)}
        onClick={onToggleBulletList}
        type={editorState.isBulletList ? 'primary' : 'default'}
      />
    </Tooltip>
  )
}
